import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react'

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ mt: '50px' }}>{children}</Box>
            )}
        </div>
    );
}

export default TabPanel